var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDataUsage = function SvgDataUsage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.5c0-2.301 1.196-4.323 3-5.478v-.022c0-2.209 1.791-4 4-4 .493 0 .965.089 1.401.252.649-1.333 2.017-2.252 3.599-2.252 1.582 0 2.95.919 3.599 2.252.436-.163.908-.252 1.401-.252 2.209 0 4 1.791 4 4 0 .518-.099 1.013-.278 1.467 1.931.854 3.278 2.786 3.278 5.033 0 2.869-2.197 5.225-5 5.478v.022h-13v-.019c-3.356-.255-6-3.059-6-6.481zm5-5.5v-.002c.001-1.104.896-1.998 2-1.998.25 0 .485.045.7.126.966.361 2.048-.071 2.499-.998.327-.671 1.012-1.127 1.8-1.127s1.474.456 1.8 1.127c.451.927 1.533 1.359 2.499.998.215-.081.45-.126.7-.126 1.105 0 2 .895 2 2 0 .263-.05.509-.138.733-.394.998.07 2.129 1.052 2.563 1.233.545 2.087 1.777 2.087 3.203 0 1.825-1.398 3.325-3.18 3.486l-.159.014h-12.336l-.173-.013c-2.321-.177-4.152-2.119-4.152-4.487 0-1.591.824-2.991 2.078-3.794.576-.369.923-1.006.922-1.69v-.016zm2 2c0-.552.448-1 1-1h4c.552 0 1 .448 1 1s-.448 1-1 1h-4c-.552 0-1-.448-1-1zm0 4c0-.552.448-1 1-1h8c.552 0 1 .448 1 1s-.448 1-1 1h-8c-.552 0-1-.448-1-1z",
    fill: "#A4A2A2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDataUsage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/data-usage.95cbfb71.svg";
export { ForwardRef as ReactComponent };